/* eslint-disable */
import { FILTER_ADDRESS_TOGGLED_ALL } from '../Filters.types';

/**
 * Action to toggle all the addresses in the filters
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, FILTER_ADDRESS_TOGGLED_ALL>>} The created `Action`
 */
const filtersToggleAllAddresses = () => ({ fromPayload }) => {
  return fromPayload(null, { debounce: true }, FILTER_ADDRESS_TOGGLED_ALL);
};

export default filtersToggleAllAddresses;
